(angular => {
  "use strict";

  angular.module("EventCompany").controller("EventCompany.ListCtrl", [
    "$scope",
    "$timeout",
    "$q",
    "Loader",
    "Toast",
    "EventService",
    "EventCompanyService",
    "AuthService",
    ListCtrl
  ]);

  function ListCtrl($scope, $timeout, $q, Loader, Toast, EventService, EventCompanyService, authService) {
    let queryTimeout = null;
    this.promiseCompany = null;
    this.promiseExhibitor = null;
    this.orderBy = 'company.name';
    this.user = authService.getTokenData();

    EventService.current().then(event => {
      this.event = event;
    });

    this.load = () => {
      const query = angular.copy(this.query) || {};

      // Carrega em páginas e vai juntando. O dado final é o mesmo (todas as
      // empresas, todos os campos), mas cada resposta é pequena — evita a
      // resposta única de 16 MB que estourava o navegador (ERR_HTTP2_PROTOCOL_ERROR)
      // em eventos grandes. Backend: sem page devolve tudo; com page devolve
      // { results, total }.
      const pageSize = 100;
      this.eventCompanies = [];

      // withAirTravel=false: esta tela usa só a coluna `air_travel_spots`, nunca a
      // relação air_travel. Sem o corte, cada empresa vinha com todas as passagens,
      // o PARTICIPANTE inteiro de cada uma e os trechos — a resposta estourava com
      // ERR_HTTP2_PROTOCOL_ERROR e o recarregamento depois de salvar morria em
      // "e.filter is not a function", deixando a vaga editada com cara de não salva.
      // As telas de Passagens Aéreas não mandam o parâmetro e seguem recebendo tudo.
      const fetchPage = page =>
        EventCompanyService.list(angular.extend({}, query, { page, pageSize, withAirTravel: false }))
          .then(res => {
            const rows = res && res.results ? res.results : (res || []);
            const total = res && typeof res.total === 'number' ? res.total : rows.length;
            this.eventCompanies = this.eventCompanies.concat(rows);
            if (rows.length === pageSize && this.eventCompanies.length < total) {
              return fetchPage(page + 1);
            }
          });

      this.promiseCompany = fetchPage(1);

      this.promiseExhibitor = EventCompanyService.listExhibitors()
        .then(exhibitors => this.eventExhibitors = exhibitors);

      return $q.all([
          this.promiseCompany,
          this.promiseExhibitor
        ])
        .catch(err => Toast.httpHandler(err));
    };

    this.form = ($event, eventCompany) => {
      if (this.currentTab === 0) {
        return EventCompanyService.form($event, eventCompany)
          .then(() => this.load());
      }
      return EventCompanyService.formExhibitor($event, eventCompany)
        .then(() => this.load());
    };

    this.remove = (eventCompany) => {
      Loader.add(EventCompanyService.remove(eventCompany.id)).then(() => {
        Toast.show("Empresa excluída com sucesso", "success");
        this.load();
      }).catch(err => Toast.httpHandler(err));
    };

    this.removeExhibitor = (eventCompany) => {
      Loader.add(EventCompanyService.removeExhibitor(eventCompany.id)).then(() => {
        Toast.show("Empresa excluída com sucesso", "success");
        this.load();
      }).catch(err => Toast.httpHandler(err));
    };

    $scope.$watch(() => this.query, () => {
      $timeout.cancel(queryTimeout);
      queryTimeout = $timeout(() => this.load(), 500);
    }, true);

    $scope.$watch('headerTabs.current', value => {
      this.currentTab = value;
    });

  }
})(angular || {});
